import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import carAndDriverPlacement from "../../../assets/images/ad_preview/caranddriver.png";
import vergePlacement from "../../../assets/images/ad_preview/verge.png";
import espnPlacement from "../../../assets/images/ad_preview/espn.png";
import AdDesignPreview from "../../partner-dashboard/components/ad-designs/ad-design-preview";
import "./preview-carousel.styles.scss";

const propTypes = {
  template: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    previewPath: PropTypes.string.isRequired,
    placements: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryMimeType: PropTypes.string.isRequired
  }).isRequired
};

const items = [
  {
    key: "caranddriver",
    src: carAndDriverPlacement,
    altText: "Car and Driver",
    // coefficient by which to scale the ad preview
    adScale: 0.42,
    topPosition: "57.3%",
    leftPosition: "29%"
  },
  {
    key: "verge",
    src: vergePlacement,
    altText: "The Verge",
    adScale: 0.42,
    topPosition: "7.5%",
    leftPosition: "29%"
  },
  {
    key: "espn",
    src: espnPlacement,
    altText: "ESPN",
    adScale: 0.42,
    topPosition: "12.5%",
    leftPosition: "29%"
  }
];

const BannerPreviewCarousel = ({ template }) => {
  const ref = useRef(null);
  const containerWidth = 1000;
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const BANNER_SIZE_RATIO = 0.12;
  const BG_SIZE_RATIO = 0.6;

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map(item => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <div
          className="ad-design__carousel--sample-placement-bg"
          style={{
            backgroundImage: `url("${item.src}")`,
            width: containerWidth,
            height: containerWidth * BG_SIZE_RATIO
          }}
        >
          <div
            style={{
              position: "absolute",
              top: item.topPosition,
              left: item.leftPosition,
              width: containerWidth * item.adScale,
              height: containerWidth * item.adScale * BANNER_SIZE_RATIO
            }}
          >
            <AdDesignPreview
              url={template.previewPath}
              mimeType={template.primaryMimeType}
              title={template.displayName}
              width={containerWidth * item.adScale}
              height={containerWidth * item.adScale * BANNER_SIZE_RATIO}
              exactSize
            />
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div ref={ref} className="py-0">
      <Carousel
        className="ad-design__carousel"
        activeIndex={activeIndex}
        next={next}
        previous={previous}
      >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
      <small>
        * The above sample placements are for example purposes only. Your specific ad may be
        displayed on other websites.
      </small>
    </div>
  );
};

BannerPreviewCarousel.propTypes = propTypes;

export default BannerPreviewCarousel;
